import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { handleLabParamCreateAndUpdate } from '../../commonHandlerFunction/Parameter/ParameterHandler';
import { decryptDataForURL } from '../../../../utills/useCryptoUtils';


const ParameterBtns = ({ formData, handleSubmit, setIsOverlayLoader, viewOnly, setFormData }) => {
    const navigate = useNavigate();
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.split("?")[1]);
    const useFor = decryptDataForURL(params.get("useFor"));
    return (

        <div className="auditBtns">
            <Button
                type="button"
                className="cancelBtn"
                onClick={() => navigate(-1)}
            >
                Back
            </Button>
            {
                !viewOnly && (
                    <Button
                        type="button"
                        className="submitBtn"
                        onClick={() =>
                            handleLabParamCreateAndUpdate(formData, handleSubmit, setFormData, setIsOverlayLoader, navigate, useFor)
                        }
                    >
                        {formData[0]?.lp_id ? useFor === "approve" ? "Approve" : "Update" : "Create"}
                    </Button>
                )
            }
            {
                useFor === "approve" && (
                    <Button
                        type="button"
                        className="submitBtn"
                        onClick={() =>
                            handleLabParamCreateAndUpdate(formData, handleSubmit, setFormData, setIsOverlayLoader, navigate, useFor)
                        }
                    >
                        {formData[0]?.lp_id ? useFor === "approve" ? "Approve" : "Update" : "Create"}
                    </Button>
                )
            }



        </div>
    )
}

export default ParameterBtns
